import classNames from 'classnames/bind';
import {
  PriceTransparencyBaggage,
  PriceTransparencyBaggageCondition,
} from 'types/apollo';
import RouteInfoWithLogo from './ModalContent/RouteInfoWithLogo';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface BaggageProps {
  baggagePolicy: (PriceTransparencyBaggage | undefined | null)[];
}

const formatBaggageInfo = ({
  available,
  baggageType,
  conditions,
}: {
  available: boolean;
  baggageType: 'cabin' | 'checked';
  conditions?: PriceTransparencyBaggageCondition[] | null;
}) => {
  if (!conditions?.filter(cond => cond.type === baggageType)?.length) {
    return '정보확인필요';
  }

  const validCondition = conditions?.filter(
    cond => cond.type === baggageType && cond.quantity,
  );

  if (!available || !validCondition?.length) {
    return '불가능';
  }

  const minimumQuantity = validCondition?.reduce((acc: number | null, cur) => {
    if (cur?.quantity && cur.quantity < (acc ?? Infinity)) {
      return cur.quantity;
    }
    return acc;
  }, null);

  const minimumWeight = validCondition?.reduce((acc: number | null, cur) => {
    if (cur?.weight && cur.weight < (acc ?? Infinity)) {
      return cur.weight;
    }
    return acc;
  }, null);

  const quantityText = minimumQuantity ? `${minimumQuantity}pc` : '';
  const weightText = minimumWeight ? `${minimumWeight}kg` : '';
  const separator = minimumQuantity && minimumWeight ? ', ' : '';

  return `${quantityText}${separator}${weightText}`;
};

const Baggage = ({ baggagePolicy }: BaggageProps) => {
  return (
    <div className={cx('Baggage')}>
      <div className={cx('panel')} data-type="panel">
        {baggagePolicy.map((policy, index) => (
          <div key={index} className={cx('section')}>
            <RouteInfoWithLogo routeIndex={index} />
            <table className={cx('table')}>
              <thead>
                <tr>
                  <th>타입</th>
                  <th>수량 (무게)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>기내 수하물</td>
                  <td>
                    {formatBaggageInfo({
                      available: policy?.available ?? false,
                      baggageType: 'cabin',
                      conditions: policy?.conditions,
                    })}
                  </td>
                </tr>
                <tr>
                  <td>위탁 수하물</td>
                  <td>
                    {formatBaggageInfo({
                      available: policy?.available ?? false,
                      baggageType: 'checked',
                      conditions: policy?.conditions,
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}

        <dl className={cx('term')}>
          <div className={cx('row')}>
            <dt>기내 수하물 :</dt>
            <dd>비행기 탑승 시 휴대할 수 있는 수하물</dd>
          </div>
          <div className={cx('row')}>
            <dt>위탁 수하물 :</dt>
            <dd>체크인 시 항공기의 화물칸으로 운송을 요청할 수 있는 수하물</dd>
          </div>
        </dl>
      </div>

      <div className={cx('footnote')}>
        <p className={cx('text')}>
          본 정보는 해당 항공사의 수하물 규정에 대한 참고용 안내입니다. 자세한
          내용은 항공권 예약 시 여행사 홈페이지에서 확인하시길 바랍니다.
        </p>
      </div>
    </div>
  );
};

export default Baggage;
